import { Badge, Box, Button, Checkbox, FormControl, IconButton, InputLabel, MenuItem, Select, TableCell, TableHead, TableRow, TextField, Typography, useTheme } from "@mui/material";
import TemplateLoaderComponent from "../../../loader/TemplateLoaderComponent";
import { PeopleAltOutlined, SearchOutlined } from "@mui/icons-material";
import { useState } from "react";
import { useApplicationContext } from "../../../../context/ApplicationContext";
import { useEffect } from "react";
import { TableVirtuoso } from "react-virtuoso";
import { TableComponents } from "../../../common/previewTemplate/StaticComponents";
import { OrganisationCustomIcon } from "../../../styled/CustomIcons";
import { formatDate } from "../../../../utils/DateTime";
import CreateOrganisationComponent from "./create";

import ConfirmationDialog from "../../../dialog/ConfirmationDialog";
import CreateLicensePackageComponent from "./create";
import EditLicensePackageComponent from "./edit";
import { LicenseDuration, Severity } from "../../../../constant/ApplicationVariables";
import useErrorHandler from "../../../../api/errorHandler/useErrorHandler";
import { HttpStatusCode } from "axios";
import { getOrganisationList_API } from "../../../../api/controller/OrganisationController";
import { deleteLicense_API, getLicenseList_API } from "../../../../api/controller/LicenseController";
import BadgeComponent from "../../../common/Badge"
import { debounce } from "../../../../utils/Functions";
import DeleteConfirmationDialog from "../../../dialog/DeleteConfirmationDialog";


let dummyList = [
    {
        name: "Starter Plan",
        description: "This is a starter plan.",
        duration: LicenseDuration.monthly,
        basePrice: 10,
        includedUsers: 5,
        createdAt: "2024-06-20T12:34:56Z",
    },
    {
        name: "Pro Plan",
        description: "This is a pro plan.",
        duration: LicenseDuration.quarterly,
        basePrice: 10,
        includedUsers: 5,
        createdAt: "2024-06-21T12:34:56Z"
    }
]




export default function LicensePackageContainer() {
    const {
        handleSnackbar,

        licenseList,
        setLicenseList,
        currentLicenseData,
        setCurrentLicenseData,
        invoicesList,
        setInvoicesList,
        currentInvoiceData,
        setCurrentInvoiceData,
        openCreateOrganisationDialog,
        setOpenCreateOrganisationDialog,
        openEditOrganisationDialog,
        setOpenEditOrganisationDialog,
        openDeleteOrganisationDialog,
        setOpenDeleteOrganisationDialog,
        openCreateLicenseDialog,
        setOpenCreateLicenseDialog,
        openEditLicenseDialog,
        setOpenEditLicenseDialog,
        openDeleteLicenseDialog,
        setOpenDeleteLicenseDialog

    } = useApplicationContext();
    const theme = useTheme();
    const errorHandler = useErrorHandler();


    const [loading, setLoading] = useState(false);
    const [openLicenseAssignDialog, setOpenLicenseAssignDialog] = useState(false);
    const [searchText, setSearchText] = useState(""); // to store the search text
    const [statusFilterText, setStatusFilterText] = useState(""); // To store the active field status filter value
    const [selectedItemsList, setSelectedItemsList] = useState([]); // To store the checkbox selected items
    const [filteredList, setFilteredList] = useState([]); // To store the filtered list, after search and applying filter




    const handleChangeSearchTerm = (e) => {
        setSearchText(e.target.value);
    }


    // Functions to handle the assigned users dialog events
    const handleToggleLicenseAssignDialog = () => {
        if (!openLicenseAssignDialog) {
            setOpenLicenseAssignDialog(true);
        } else {
            setOpenLicenseAssignDialog(false);
        }
    }

    const handleContinueLicenseAssignDialog = () => { }


    // Functions to handle the create organisation dialog events
    const handleCloseCreateDialog = () => {
        setOpenCreateLicenseDialog(false);
    }

    const handleConfirmCreateDialog = () => {
        handleGetList()
    }



    const handleCloseEditDialog = () => {
        setOpenEditLicenseDialog(false);
        setCurrentLicenseData(null);
    }
    const handleConfirmEditDialog = () => {
        handleCloseEditDialog();
    }






    const handleCloseDeleteDialog = () => {
        setOpenDeleteLicenseDialog(false);
        setCurrentLicenseData(null);
    }
    const handleConfirmDeleteDialog = () => {
        handleDeleteItem();
    }



    const handleDeleteItem = async () => {
        setLoading(true);
        try {
            let query = `/${currentLicenseData?.code}`
            const response = await deleteLicense_API(query);
            if (response) {
                errorHandler(response, setLoading);
            }
            if (response.status === HttpStatusCode.Ok) {
                handleSnackbar(response?.message || "License Deleted Successfully", Severity.success)
                handleGetList();
            }
        } catch (error) {
            console.log(error, error?.message, "projectreponse errorr");
            handleSnackbar(String(error), Severity.error);
        } finally {
            setLoading(false);
        }
    }







    const handleGetList = async () => {
        setLoading(true);
        try {
            let query = `active=false`
            const response = await getLicenseList_API(query);
            if (response) {
                errorHandler(response, setLoading);
            }
            if (response.status === HttpStatusCode.Ok) {
                setLicenseList(response.data);

                if (openCreateLicenseDialog) {
                    handleCloseCreateDialog()
                }

                if (openDeleteLicenseDialog) {
                    handleCloseDeleteDialog()
                }
            }
        } catch (error) {
            console.log(error, error?.message, "projectreponse errorr");
            handleSnackbar(String(error), Severity.error);
        } finally {
            setLoading(false);
        }
    }


    useEffect(() => {
        handleGetList()
        // setLicenseList([...dummyList]);
    }, []);


    // To filter the list, by search and filter
    useEffect(() => {
        let func = debounce(() => {
            let list = [...licenseList];
            if (statusFilterText === "true") {
                list = list.filter((item) => item.active === true);
            } else if (statusFilterText === "false") {
                list = list.filter((item) => item.active === false);
            }
            if (searchText) {
                list = list.filter((item) => item.name.toLowerCase().includes(searchText.toLowerCase()));
            }
            setFilteredList(list);
        }, 500);
        func();
    }, [searchText, statusFilterText, licenseList]);


    return (
        <Box className="  flex-1 flex flex-col gap-4 overflow-hidden relative " >
            {loading && <TemplateLoaderComponent />}
            <Box className="flex-1 flex flex-col gap-4 px-4 py-0 overflow-y-auto">


                <Box className="flex items-center gap-4">
                    <TextField type="search" placeholder="Search" slotProps={{ input: { startAdornment: <SearchOutlined /> } }} defaultValue={searchText} onChange={handleChangeSearchTerm} />
                    <FormControl className="w-40">
                        <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            displayEmpty
                            name="active"
                            value={statusFilterText}
                            onChange={(e) => setStatusFilterText(e.target.value)}
                        >
                            <MenuItem value="">All Status</MenuItem>
                            <MenuItem value="true">Active</MenuItem>
                            <MenuItem value="false">Inactive</MenuItem>
                        </Select>
                    </FormControl>
                </Box>

                <Box className="flex-1 flex flex-col gap-4">
                    <TableComponent list={filteredList} selectedItemsList={selectedItemsList} setSelectedItemsList={setSelectedItemsList} />
                </Box>
            </Box>


            {openCreateLicenseDialog && (
                <CreateLicensePackageComponent open={openCreateLicenseDialog} handleClose={handleCloseCreateDialog} handleContinue={handleConfirmCreateDialog} />
            )}

            {openEditLicenseDialog && currentLicenseData && (
                <EditLicensePackageComponent open={openEditLicenseDialog} handleClose={handleCloseEditDialog} handleContinue={handleConfirmEditDialog} />
            )}


            {openDeleteLicenseDialog && currentLicenseData && (
                <DeleteConfirmationDialog open={openDeleteLicenseDialog} data={`${currentLicenseData?.name}`} title={"Delete License Package"} description={"Are you sure you want to delete this license package?"} handleClose={handleCloseDeleteDialog} handleContinue={handleConfirmDeleteDialog} />
            )}



        </Box>
    )
}


function TableComponent({ list, selectedItemsList, setSelectedItemsList, }) {
    const { currentLicenseData, setCurrentLicenseData, profileDetails, userDetail, setUserDetail, openEditLicenseDialog, setOpenEditLicenseDialog, openDeleteLicenseDialog, setOpenDeleteLicenseDialog } = useApplicationContext();
    const theme = useTheme();





    const [localList, setLocalList] = useState([]); // to store the list locally
    const [currentListData, setCurrentListData] = useState(null); // to store the current list item data



    const handleChangeCheckbox = (e, data) => {
        let foundItem = selectedItemsList?.find((item) => item?.code === data?.code);

        if (e.target.name === "selectAll") {
            if (selectedItemsList?.length === list?.length) {
                setSelectedItemsList([]);
            } else {
                setSelectedItemsList(list?.filter((item) => item?.code !== data?.code));
            }

        } else {

            setSelectedItemsList(
                e.target.checked && !foundItem
                    ? [...selectedItemsList, data]
                    : selectedItemsList.filter((item) => item?.code !== data?.code)
            );
        }
    }


    const table_columns = [
        {
            data: <Checkbox name="selectAll" checked={selectedItemsList?.length > 0 && selectedItemsList?.length === list?.length} indeterminate={selectedItemsList?.length > 0 && selectedItemsList?.length < list?.length} onChange={handleChangeCheckbox} />,
            dataKey: "checkbox",
            padding: "none",
            px: "0.2rem",
            align: "center",
            background: theme.palette.header.main,

            sx: {
                minWidth: "60px",
                maxWidth: "60px",
                border: "0px solid #000"
            },
        },
        // {
        //     data: "S.No.",
        //     dataKey: "index",
        //     padding: "none",
        //     px: "0.2rem",
        //     align: "center",
        //     background: theme.palette.header.main,

        //     sx: {
        //         minWidth: "40px",
        //         maxWidth: "40px",
        //         border: "0px solid #000"
        //     },
        // },
        {
            data: "Name",
            dataKey: "name",
            padding: "none",
            px: "0.2rem",
            align: "left",
            background: theme.palette.header.main,

            sx: {
                minWidth: "100px",
                maxWidth: "100px",
                border: "0px solid #000"
            },
        },
        {
            data: "Description",
            dataKey: "description",
            padding: "none",
            px: "0.2rem",
            align: "left",
            background: theme.palette.header.main,

            sx: {
                minWidth: "180px",
                width: "100%",
                maxWidth: "100%",
                border: "0px solid #000"
            },
        },
        {
            data: "Duration",
            dataKey: "planBilling",
            padding: "none",
            px: "0.2rem",
            align: "center",
            background: theme.palette.header.main,

            sx: {
                minWidth: "100px",
                maxWidth: "100px",
                border: "0px solid #000"
            },
        },
        {
            data: "Price",
            dataKey: "basePrice",
            padding: "none",
            px: "0.2rem",
            align: "center",
            background: theme.palette.header.main,

            sx: {
                minWidth: "100px",
                maxWidth: "100px",
                border: "0px solid #000"
            },
        },
        {
            data: "Included Users",
            dataKey: "includedUsers",
            padding: "none",
            px: "0.2rem",
            align: "center",
            background: theme.palette.header.main,

            sx: {
                minWidth: "100px",
                maxWidth: "100px",
                border: "0px solid #000"
            },
        },
        {
            data: "Status",
            dataKey: "active",
            padding: "none",
            px: "0.2rem",
            align: "center",
            background: theme.palette.header.main,

            sx: {
                minWidth: "100px",
                maxWidth: "100px",
                border: "0px solid #000"
            },
        },
        {
            data: "Created At",
            dataKey: "createdAt",
            padding: "none",
            px: "0.2rem",
            align: "center",
            background: theme.palette.header.main,

            sx: {
                minWidth: "120px",
                maxWidth: "120px",
                border: "0px solid #000"
            },
        },
        {
            data: "Action",
            dataKey: "action",
            padding: "none",
            px: "0.2rem",
            align: "center",
            background: theme.palette.header.main,
            sx: {
                minWidth: "160px",
                maxWidth: "160px",
                border: "0px solid #000"
            },
        }

    ];


    const handleOpenEditDialog = (data) => {
        setCurrentLicenseData(data);
        setOpenEditLicenseDialog(true);
    }



    // Functions to handle item delete
    const handleRemoveItem = (e, data, key) => {
        handleOpenDeleteDialog(data);
    }

    const handleOpenDeleteDialog = (data) => {
        setCurrentLicenseData(data);
        setOpenDeleteLicenseDialog(true);
    }






    // set the list
    useEffect(() => {
        if (list) {
            setLocalList(list)
        }
    }, [list]);


    console.log(profileDetails, userDetail, " userDetail ")


    return (
        <Box className="flex-1 flex flex-col gap-4">


            <TableVirtuoso
                style={{ height: "100%", width: "100%", overflowX: 'auto', borderRadius: theme.shape.borderRadius, boxShadow: "none", border: `1px solid ${theme.palette.divider}` }}
                data={localList}
                components={TableComponents}
                fixedHeaderContent={() => (
                    <TableHead>
                        {
                            table_columns?.map((item, index, arr) => (
                                <TableCell
                                    key={index}
                                    align={item?.align}
                                    padding={item?.padding}
                                    className="whitespace-nowrap"
                                    sx={{
                                        py: 0.5,
                                        margin: "0 0rem !important",
                                        background: item?.background,
                                        ...item?.sx,
                                        borderBottom: `1px solid ${theme.palette.divider}`,
                                    }}
                                >
                                    <Box className="py-1 flex items-center gap-2 min-w-full " sx={{ px: item?.px }}>
                                        <Typography className="flex-1 whitespace-nowrap" textAlign={item?.align} color="textPrimary" > {item?.data}</Typography>
                                    </Box>
                                </TableCell>
                            ))
                        }
                    </TableHead>
                )}


                itemContent={(itemIndex, itemData) => (
                    <TableRow className="cursor-pointer">

                        {
                            table_columns?.map((item, index, arr) => {
                                console.log(itemData[item?.dataKey], itemData, item, "dataKey")
                                return (
                                    <TableCell padding={item?.padding} align={item?.align} sx={{ py: 0.5, cursor: item?.dataKey === "title" && "pointer", ...item?.sx }} >
                                        {
                                            item?.dataKey === "index" ? (
                                                <Box className="flex items-center py-1 " sx={{ px: item?.px }}>
                                                    <Typography textAlign={item?.align} fontWeight={"bold"} className="flex-1">{itemIndex + 1}.</Typography>
                                                </Box>
                                            ) : item?.dataKey === "checkbox" ? (
                                                <Box className="flex items-center justify-center py-1 gap-2 " sx={{ px: item?.px }}>
                                                    <Checkbox name="list" value={itemData?.email} checked={selectedItemsList?.some((item) => item?.code === itemData?.code)} onChange={(e) => handleChangeCheckbox(e, itemData)} />
                                                </Box>
                                            ) : item?.dataKey === "name" ? (
                                                <Box className="flex items-center py-1 " sx={{ px: item?.px }}>
                                                    <Typography textAlign={item?.align} fontWeight={"bold"} className="flex-1 line-clamp-2">{itemData[item?.dataKey]}</Typography>
                                                </Box>
                                            ) : item?.dataKey === "description" ? (
                                                <Box className="flex items-center py-1 " sx={{ px: item?.px }}>
                                                    <Typography textAlign={item?.align} className="flex-1 line-clamp-2">{itemData[item?.dataKey]}</Typography>
                                                </Box>
                                            ) : item?.dataKey === "email" ? (
                                                <Box className="flex items-center py-1 " sx={{ px: item?.px }}>
                                                    <Typography textAlign={item?.align} fontWeight={"bold"} className="flex-1">{itemData[item?.dataKey]}</Typography>
                                                </Box>
                                            ) : item?.dataKey === "active" ? (
                                                <Box className="flex items-center py-1 " sx={{ px: item?.px }}>
                                                    {/* <Typography textAlign={item?.align} fontWeight={"bold"} className="flex-1">{itemData[item?.dataKey] ? "Active" : "Inactive"}</Typography> */}
                                                    <BadgeComponent text={itemData[item?.dataKey] ? "Active" : "Inactive"} />
                                                </Box>
                                            ) : item?.dataKey === "duration" ? (
                                                <Box className="flex items-center py-1 " sx={{ px: item?.px }}>
                                                    <Typography textAlign={item?.align} fontWeight={"bold"} className="flex-1">{itemData[item?.dataKey]}</Typography>
                                                </Box>
                                            ) : item?.dataKey === "basePrice" ? (
                                                <Box className="flex items-center py-1 " sx={{ px: item?.px }}>
                                                    <Typography textAlign={item?.align} fontWeight={"bold"} className="flex-1">${itemData[item?.dataKey]}</Typography>
                                                </Box>
                                            ) : item?.dataKey === "features" ? (
                                                <Box className="flex items-center py-1 " sx={{ px: item?.px }} title={`${itemData[item?.dataKey]?.map((item) => item).join(", ")}`}>
                                                    <Typography textAlign={item?.align} className="flex-1 line-clamp-2">{itemData[item?.dataKey]?.map((item) => item).join(", ")}</Typography>
                                                </Box>
                                            ) : item?.dataKey === "createdBy" ? (
                                                <Box className="flex items-center py-1 " sx={{ px: item?.px }}>
                                                    <Typography textAlign={item?.align} fontWeight={"bold"} className="flex-1">{itemData[item?.dataKey]?.name}</Typography>
                                                </Box>
                                            ) : (item?.dataKey === "createdAt" || item?.dataKey === "lastModifiedAt" || item?.dataKey === "closureDate" || item?.dataKey === "impactDate") ? (
                                                <Box className="flex items-center py-1 " sx={{ px: item?.px }}>
                                                    <Typography textAlign={item?.align} className="flex-1">{itemData[item?.dataKey] ? formatDate(itemData[item?.dataKey]) : "-"}</Typography>
                                                </Box>
                                            ) : (item?.dataKey === "action") ? (
                                                <Box className="flex items-center py-1 gap-1" sx={{ justifyContent: item?.align === "left" ? "flex-start" : item?.align === "right" ? "flex-end" : "center", px: item?.px }}>
                                                    {/* <Button color="info" disabled={true}>Resend</Button> */}
                                                    {/* <Button color="info">Assign Project</Button> */}
                                                    <Button color="info" variant="outlined" onClick={() => handleOpenEditDialog(itemData)}>Edit</Button>
                                                    <Button color="error" variant="outlined"  onClick={() => handleOpenDeleteDialog(itemData)}>Delete</Button>
                                                </Box>
                                            )
                                                : (
                                                    <Box className="flex-1 flex items-center  py-1  " sx={{ px: item?.px }}>
                                                        <Typography textAlign={item?.align} className="flex-1">{itemData[item?.dataKey] ? itemData[item?.dataKey] : "-"}</Typography>
                                                    </Box>
                                                )
                                        }
                                    </TableCell>
                                )
                            })
                        }

                    </TableRow>

                )}
            />




        </Box>
    )
}